import { render, staticRenderFns } from "./forgetPwd.vue?vue&type=template&id=62dc0dd5&scoped=true&"
import script from "./forgetPwd.vue?vue&type=script&lang=js&"
export * from "./forgetPwd.vue?vue&type=script&lang=js&"
import style0 from "./forgetPwd.vue?vue&type=style&index=0&id=62dc0dd5&scoped=true&lang=css&"
import style1 from "./forgetPwd.vue?vue&type=style&index=1&id=62dc0dd5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dc0dd5",
  null
  
)

export default component.exports